import {
  generalFields,
  summaryFields,
} from '@smartflip/data-field-configuration';

export const createWorkflowFieldList = (usableFields: string[]) => [
  ...generalFields.filter((field) => usableFields.includes(field.name)),
  ...summaryFields.filter((field) => usableFields.includes(field.name)),
];
